import { ref, watch } from 'vue';

const LOCAL_STORAGE_LAYOUT_KEY = 'CFS_LAYOUT';
type LayoutType = 'desktop' | 'tablet';

function detectDeviceLayout(): LayoutType {
  if (typeof window !== 'undefined') {
    if (window.innerWidth <= 1026) {
      return 'tablet';
    }
  }
  return 'desktop';
}

function getInitialLayout(): LayoutType {
  const saved = localStorage.getItem(LOCAL_STORAGE_LAYOUT_KEY);
  if (saved === 'desktop' || saved === 'tablet') return saved;
  // return detectDeviceLayout();
  return 'desktop';
}

const layout = ref<LayoutType>(getInitialLayout());

updateBodyClass(layout.value);

watch(layout, (newLayout) => {
  updateBodyClass(newLayout);
});

function updateBodyClass(layoutType: LayoutType) {
  if (typeof document !== 'undefined') {
    document.body.classList.remove('layout-desktop', 'layout-tablet');
    document.body.classList.add(`layout-${layoutType}`);
  }
}

export function useLayout() {
  function setLayout(newLayout: LayoutType) {
    layout.value = newLayout;
    localStorage.setItem(LOCAL_STORAGE_LAYOUT_KEY, newLayout);
  }

  return {
    layout,
    setLayout,
  };
}
